/*  */
import { AxiosResponse } from 'axios';
import { AvailableLanguages } from '../context/LanguageContext/types';
import api from './api';
import { QuestionType } from '../types/entities';

const questionService = {
  getRandomQuestions: (locale: AvailableLanguages = 'en'): Promise<AxiosResponse<QuestionType[]>> =>
    api.get<any>(`/api/random-questions?locale=${locale}`),
  getSurveyQuestions: (locale: AvailableLanguages = 'en'): Promise<AxiosResponse<QuestionType[]>> =>
    api.get<any>(`/api/survey-questions?locale=${locale}`),
};

export default questionService;
